import { slicedToArray as _slicedToArray, asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useCallback, useEffect } from 'react';
import { IoGiftOutline } from '@react-icons/all-files/io5/IoGiftOutline';
import { IntersectionObserver } from '@bucketplace/design-system';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../contexts/internal/StickyContext.js';
import '../../contexts/internal/EditorContext.js';
import { useStoreItemsContext } from '../../contexts/external/StoreItemsContext.js';
import { useEditorInfoContext } from '../../contexts/external/EditorInfoContext.js';
import '../../components/Canvas/Canvas.style.js';
import '../../components/Canvas/PreviewModeContainer.js';
import '../../components/Duration/DurationInput.js';
import 'react-hook-form';
import '../../components/FieldItem.js';
import '../../components/FormGroup/FormGroup.js';
import '../../components/FormGroup/LogDataFormGroup.js';
import '../../components/Header/index.js';
import '../../components/Input/ColorPickerField/index.js';
import '../../components/Input/URLInput.js';
import '../../components/Inspector/Inspector.js';
import '../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../components/Tooltip/Tooltip.js';
import '../../components/Toolbar/Toolbar.style.js';
import '../../components/TreeList/Draggable.js';
import { EditorPlaceholder } from '../../components/EditorPlaceholder/EditorPlaceholder.js';
import '../../components/FormContent.js';
import { Exhibitions } from '../../components/Exhibitions/index.js';

function ProductList(_ref) {
  var type = _ref.type,
    badgeType = _ref.badgeType,
    useBuyButton = _ref.useBuyButton,
    products = _ref.products,
    logData = _ref.logData;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    storeItems = _useState2[0],
    setStoreItems = _useState2[1];
  var _useStoreItemsContext = useStoreItemsContext(),
    getStoreItems = _useStoreItemsContext.getStoreItems,
    getStoreItemHref = _useStoreItemsContext.getStoreItemHref,
    linkComponent = _useStoreItemsContext.linkComponent,
    experimentType = _useStoreItemsContext.experimentType;
  var _useEditorInfoContext = useEditorInfoContext(),
    isInitialLoadAllContent = _useEditorInfoContext.isInitialLoadAllContent;
  var concatStoreData = function concatStoreData(badgeList, addedStoreItems) {
    var newStoreItems = badgeList.map(function (badge) {
      var findStoreItem = addedStoreItems.find(function (storeItem) {
        return storeItem.id === badge.id;
      }) || storeItems.find(function (storeItem) {
        return storeItem.id === badge.id;
      });
      if (findStoreItem) {
        return _objectSpread2(_objectSpread2(_objectSpread2({}, findStoreItem), badge), {}, {
          // FIXME: 오시즌위크 상품명 실시간 반영을 위해 임시로 storeItem name 사용
          name: findStoreItem.name,
          getStoreItemHref: getStoreItemHref,
          linkComponent: linkComponent
        });
      }
      return null;
    }).filter(Boolean);
    setStoreItems(newStoreItems);
  };
  var getProducts = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var existTextBadgeList, newIds, newStoreItems;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // inspector에서 빈 id들을 제외한 텍스트 뱃지 리스트들
          existTextBadgeList = products.filter(function (product) {
            return product.id;
          });
          newIds = existTextBadgeList.filter(function (_ref3) {
            var id = _ref3.id;
            return !storeItems.some(function (storeItem) {
              return storeItem.id === id;
            });
          }).map(function (_ref4) {
            var _id$toString;
            var id = _ref4.id;
            return (_id$toString = id === null || id === void 0 ? void 0 : id.toString()) !== null && _id$toString !== void 0 ? _id$toString : '';
          });
          _context.next = 4;
          return getStoreItems === null || getStoreItems === void 0 ? void 0 : getStoreItems(newIds);
        case 4:
          newStoreItems = _context.sent;
          concatStoreData(existTextBadgeList, newStoreItems !== null && newStoreItems !== void 0 ? newStoreItems : []);
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [products]);
  useEffect(function () {
    if (isInitialLoadAllContent) {
      getProducts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);
  if (products.length === 0) {
    return jsx(EditorPlaceholder, {
      icon: jsx(IoGiftOutline, null),
      message: "\uC0C1\uD488\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694."
    });
  }
  var ExhibitionElement = jsx(Exhibitions, {
    storeItemList: storeItems,
    colType: type,
    badgeType: badgeType,
    useBuyButton: useBuyButton,
    logData: logData,
    experimentType: experimentType
  });
  if (isInitialLoadAllContent) {
    return ExhibitionElement;
  }
  return jsx(IntersectionObserver, {
    onIntersect: getProducts
  }, ExhibitionElement);
}

export { ProductList };
//# sourceMappingURL=ProductList.js.map
